import { isPending } from "App/apiMiddleware";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getData = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].data`), (data) => data);
export const getChanges = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].draft`), (draft) => draft);
export const getHasChanges = createSelector((state) => getChanges(state), (draft) => !isEmpty(draft));
export const getProjectId = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].projectId`), (projectId) => projectId);
export const getDraft = createSelector((state) => getData(state), (state) => getChanges(state), (state) => getProjectId(state), (data, draft, projectId) => {
    if (isNil(projectId) || !data)
        return undefined;
    return {
        ...data,
        ...(draft || {})
    };
});
export const getInProgress = (state) => isPending(state, `${actionTypes.SAVE_PROJECT}_${getProjectId(state)}`) ||
    isPending(state, `${actionTypes.GET_PROJECT}_${getProjectId(state)}`);
